import { Link } from "gatsby"
import React from "react"
import * as util from "../common/util"

const copy = {
  en: {
    home: "Home",
    about: "About",
    welcomechurch: "WelcomeChurch",
    canrefugee: "CanRefugee",
    guide: "Guide",
    connect: "Connect",
    donate: "Donate",
    signin: "Sign In",
    translate: "中文",
  },
  cn: {
    home: "主頁",
    about: "關於我們",
    welcomechurch: "歡迎教會",
    canrefugee: "難民協助",
    guide: "加拿大指南​",
    connect: "聯絡",
    donate: "奉獻",
    signin: "登入",
    translate: "English",
  },
}

const Navbar = ({ lang = "en", handleMenuToggle }) => {
  const isChinese = lang === "cn"
  const translate = key => copy[lang][key]

  const url = util.getUrl()
  const translateLink = url
    ? isChinese
      ? url.pathname.replace("/cn", "") + url.search
      : `/cn${url.pathname}` + url.search
    : null

  return (
    <ul className="nav__list collapsible__content">
      <li className="nav__item" onClick={handleMenuToggle}>
        <Link to={isChinese ? "/cn/" : "/"}>{translate("home")}</Link>
      </li>
      <li className="nav__item" onClick={handleMenuToggle}>
        <Link to={isChinese ? "/cn/about/" : "/about/"}>
          {translate("about")}
        </Link>
      </li>
      <li className="nav__item">
        <a
          href="https://www.welcomechurch.ca/"
          target="_blank"
          rel="noreferrer"
        >
          {translate("welcomechurch")}
        </a>
      </li>
      <li className="nav__item">
        <a href="https://www.canrefugee.ca/" target="_blank" rel="noreferrer">
          {translate("canrefugee")}
        </a>
      </li>
      <li className="nav__item" onClick={handleMenuToggle}>
        <Link to={isChinese ? "/cn/guide/" : "/guide/"}>
          {translate("guide")}
        </Link>
      </li>
      <li className="nav__item" onClick={handleMenuToggle}>
        <Link to={isChinese ? "/cn/connect/" : "/connect/"}>
          {translate("connect")}
        </Link>
      </li>
      <li className="nav__item" onClick={handleMenuToggle}>
        <Link to={isChinese ? "/cn/donate/" : "/donate/"}>
          {translate("donate")}
        </Link>
      </li>
      <li className="nav__item">
        <a
          href="https://canwelcomechurches.ca/"
          target="_blank"
          rel="noreferrer"
        >
          {translate("signin")}
        </a>
      </li>
      <li className="nav__item" onClick={handleMenuToggle}>
        <Link to={translateLink}>{translate("translate")}</Link>
      </li>
    </ul>
  )
}

export default Navbar
